import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import Link from 'next/link';
/* eslint-disable-next-line */

export function AppLogo(_ref) {
  var _ref$full = _ref.full,
      full = _ref$full === void 0 ? false : _ref$full,
      _ref$gotToRoot = _ref.gotToRoot,
      gotToRoot = _ref$gotToRoot === void 0 ? true : _ref$gotToRoot;
  var logo = full ? /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    xmlSpace: "preserve",
    fill: "none",
    viewBox: "0 0 330 70",
    className: "",
    children: [/*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("radialGradient", {
        gradientTransform: "matrix(0.5564587712287903,0,0,0.5215809345245361,-116.54032135009766,-210.08209228515625)",
        id: "SVGID_1_",
        cx: "194.0435",
        cy: "382.1304",
        r: "155.993",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "0",
          stopColor: "#00FFFF"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#29ABE2"
        })]
      }), /*#__PURE__*/_jsxs("radialGradient", {
        gradientTransform: "matrix(0.5564587712287903,0,0,0.5215809345245361,-116.54032135009766,-210.08209228515625)",
        id: "SVGID_2_",
        cx: "194.0435",
        cy: "382.1304",
        r: "155.993",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "0",
          stopColor: "#00FFFF"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#29ABE2"
        })]
      }), /*#__PURE__*/_jsxs("radialGradient", {
        gradientTransform: "matrix(0.5564587712287903,0,0,0.5215809345245361,-116.54032135009766,-210.08209228515625)",
        id: "SVGID_3_",
        cx: "267.8696",
        cy: "494.8261",
        r: "84.1837",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "0",
          stopColor: "#1B1464"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopOpacity: "0",
          stopColor: "#29ABE2"
        })]
      }), /*#__PURE__*/_jsxs("radialGradient", {
        gradientTransform: "matrix(0.5564587712287903,0,0,0.5215809345245361,-116.54032135009766,-210.08209228515625)",
        id: "SVGID_4_",
        cx: "398.8586",
        cy: "494.7142",
        r: "86.6895",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "0",
          stopColor: "#4D4D4D"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopOpacity: "0",
          stopColor: "#FFFFFF"
        })]
      }), /*#__PURE__*/_jsxs("radialGradient", {
        gradientTransform: "matrix(0.5564587712287903,0,0,0.5215809345245361,-116.54032135009766,-210.08209228515625)",
        id: "SVGID_5_",
        cx: "429.8841",
        cy: "548.5051",
        r: "86.3652",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "0",
          stopColor: "#4D4D4D"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopOpacity: "0",
          stopColor: "#FFFFFF"
        })]
      }), /*#__PURE__*/_jsxs("radialGradient", {
        gradientTransform: "matrix(0.5564587712287903,0,0,0.5215809345245361,-116.54032135009766,-210.08209228515625)",
        id: "SVGID_6_",
        cx: "541.4281",
        cy: "504.5188",
        r: "61.5432",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "0",
          stopColor: "#4D4D4D"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopOpacity: "0",
          stopColor: "#FFFFFF"
        })]
      }), /*#__PURE__*/_jsxs("radialGradient", {
        gradientTransform: "matrix(0.5564587712287903,0,0,0.5215809345245361,-116.54032135009766,-210.08209228515625)",
        id: "SVGID_10_",
        cx: "194.0435",
        cy: "382.1304",
        r: "155.993",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "0",
          stopColor: "#00FFFF"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#29ABE2"
        })]
      }), /*#__PURE__*/_jsxs("radialGradient", {
        gradientTransform: "matrix(0.5564587712287903,0,0,0.5215809345245361,-116.54032135009766,-210.08209228515625)",
        id: "SVGID_11_",
        cx: "194.0435",
        cy: "382.1304",
        r: "155.993",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "0",
          stopColor: "#00FFFF"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#29ABE2"
        })]
      }), /*#__PURE__*/_jsxs("radialGradient", {
        gradientTransform: "matrix(0.5564587712287903,0,0,0.5215809345245361,-116.54032135009766,-210.08209228515625)",
        id: "SVGID_12_",
        cx: "194.0435",
        cy: "382.1304",
        r: "155.993",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "0",
          stopColor: "#00FFFF"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#29ABE2"
        })]
      })]
    }), /*#__PURE__*/_jsxs("g", {
      children: [/*#__PURE__*/_jsx("rect", {
        stroke: "null",
        x: "228.99998",
        y: "170.99997",
        className: "st0",
        width: "566",
        height: "127.00001",
        fill: "none",
        id: "svg_1"
      }), /*#__PURE__*/_jsxs("g", {
        strokeWidth: "0",
        stroke: "null",
        id: "svg_2",
        children: [/*#__PURE__*/_jsx("path", {
          stroke: "null",
          className: "st1",
          d: "m90.12847,36.1041c-2.83794,-3.33812 -6.84444,-5.00718 -11.96386,-5.00718c-4.89684,0 -9.12592,1.77338 -12.63161,5.26797c-3.50569,3.49459 -5.28636,7.82371 -5.28636,12.93521c0,5.11149 1.78067,9.38846 5.28636,12.93521c3.50569,3.49459 7.73478,5.26797 12.63161,5.26797c5.17507,0 9.12592,-1.66906 11.96386,-5.00718l0,4.06833l9.51544,0l0,-34.4765l-9.51544,0l0,4.01617zm-2.89359,20.13302c-1.94761,1.82553 -4.39602,2.71222 -7.34526,2.71222c-2.94923,0 -5.342,-0.88669 -7.28961,-2.71222c-1.89196,-1.82553 -2.89359,-4.17265 -2.89359,-6.98918c0,-2.8687 0.94598,-5.16365 2.89359,-6.98918c1.89196,-1.82553 4.34038,-2.71222 7.28961,-2.71222c2.94923,0 5.39765,0.88669 7.34526,2.71222c1.94761,1.82553 2.89359,4.17265 2.89359,6.98918c0,2.8687 -1.00163,5.16365 -2.89359,6.98918z",
          fill: "#000000",
          id: "svg_3"
        }), /*#__PURE__*/_jsx("rect", {
          stroke: "null",
          x: "107.65692",
          y: "19.83078",
          className: "st1",
          width: "9.51544",
          height: "46.62934",
          fill: "#000000",
          id: "svg_4"
        }), /*#__PURE__*/_jsx("path", {
          stroke: "null",
          className: "st1",
          d: "m143.88239,31.04477c-5.67588,0 -10.35013,1.72122 -13.96712,5.21581c-3.61698,3.49459 -5.4533,7.82371 -5.4533,12.98737c0,5.21581 1.83631,9.59709 5.50894,13.03952c3.67263,3.44243 8.56947,5.16365 14.63487,5.16365c7.06703,0 12.40903,-2.45143 16.02601,-7.35429l-7.62349,-4.12049c-1.83631,2.29496 -4.61861,3.44243 -8.23559,3.44243c-5.62023,0 -9.07028,-2.13848 -10.35013,-6.4676l27.71165,0c0.22258,-1.30395 0.38952,-2.50359 0.38952,-3.65107c0,-5.16365 -1.78067,-9.49277 -5.28636,-12.98737c-3.50569,-3.49459 -7.95736,-5.26797 -13.35501,-5.26797zm-9.62674,14.96937c0.55646,-2.19064 1.66938,-3.91186 3.28311,-5.11149c1.66938,-1.19964 3.78392,-1.82553 6.34363,-1.82553c2.17019,0 4.06215,0.57374 5.78717,1.72122c1.66938,1.14748 2.78229,2.92085 3.33875,5.21581l-18.75266,0z",
          fill: "#000000",
          id: "svg_5"
        }), /*#__PURE__*/_jsx("path", {
          stroke: "null",
          className: "st1",
          d: "m189.56765,31.04477c-5.00813,0 -8.68076,1.6169 -10.96224,4.8507l0,-3.8597l-9.51544,0l0,34.4765l9.51544,0l0,-18.62044c0,-2.8687 0.7234,-5.00718 2.22584,-6.41545c1.44679,-1.40827 3.45004,-2.13848 5.89846,-2.13848c2.22584,0 3.95086,0.6259 5.28636,1.82553c1.3355,1.19964 2.00325,2.97301 2.00325,5.26797l0,20.08087l9.51544,0l0,-21.17619c0,-4.43344 -1.3355,-7.92803 -3.95086,-10.48378c-2.671,-2.55575 -6.00975,-3.80754 -10.01626,-3.80754z",
          fill: "#000000",
          id: "svg_6"
        }), /*#__PURE__*/_jsx("path", {
          stroke: "null",
          className: "st1",
          d: "m239.42636,36.1041c-2.78229,-3.33812 -6.7888,-5.00718 -11.90822,-5.00718c-4.95248,0 -9.18157,1.77338 -12.68726,5.26797c-3.50569,3.49459 -5.28636,7.82371 -5.28636,12.93521c0,5.11149 1.72502,9.38846 5.28636,12.93521c3.50569,3.49459 7.73478,5.26797 12.68726,5.26797c5.17507,0 9.12592,-1.66906 11.90822,-5.00718l0,4.06833l9.51544,0l0,-46.62934l-9.51544,0l0,16.16901zm-2.83794,20.13302c-1.89196,1.82553 -4.34038,2.71222 -7.28961,2.71222c-2.94923,0 -5.39765,-0.88669 -7.34526,-2.71222c-1.94761,-1.82553 -2.89359,-4.17265 -2.89359,-6.98918c0,-2.8687 0.94598,-5.16365 2.89359,-6.98918c1.94761,-1.82553 4.39602,-2.71222 7.34526,-2.71222c2.94923,0 5.342,0.88669 7.28961,2.71222c1.89196,1.82553 2.89359,4.17265 2.89359,6.98918c-0.05565,2.8687 -1.00163,5.16365 -2.89359,6.98918z",
          fill: "#000000",
          id: "svg_7"
        }), /*#__PURE__*/_jsx("path", {
          stroke: "null",
          className: "st1",
          d: "m285.55679,36.1041c-2.83794,-3.33812 -6.84444,-5.00718 -11.96386,-5.00718c-4.89684,0 -9.12592,1.77338 -12.63161,5.26797c-3.50569,3.49459 -5.28636,7.82371 -5.28636,12.93521c0,5.11149 1.72502,9.38846 5.28636,12.93521c3.50569,3.49459 7.73478,5.26797 12.63161,5.26797c5.17507,0 9.12592,-1.66906 11.96386,-5.00718l0,4.06833l9.51544,0l0,-34.4765l-9.51544,0l0,4.01617zm-2.89359,20.13302c-1.94761,1.82553 -4.39602,2.71222 -7.34526,2.71222c-2.94923,0 -5.342,-0.88669 -7.28961,-2.71222c-1.89196,-1.82553 -2.89359,-4.17265 -2.89359,-6.98918c0,-2.8687 0.94598,-5.16365 2.89359,-6.98918c1.89196,-1.82553 4.34038,-2.71222 7.28961,-2.71222c2.94923,0 5.39765,0.88669 7.34526,2.71222c1.94761,1.82553 2.89359,4.17265 2.89359,6.98918c0,2.8687 -1.00163,5.16365 -2.89359,6.98918z",
          fill: "#000000",
          id: "svg_8"
        }), /*#__PURE__*/_jsx("path", {
          stroke: "null",
          className: "st1",
          d: "m321.61532,31.04477c-12.63161,0 -19.14218,5.68523 -19.42041,17.16001l0,18.30749l9.62674,0l0,-18.41181c0,-5.16365 2.671,-7.77156 7.95736,-7.77156l2.671,0l0,-9.23198l-0.83469,0l0,-0.05216z",
          fill: "#000000",
          id: "svg_9"
        }), /*#__PURE__*/_jsx("g", {
          stroke: "null",
          id: "svg_39",
          children: /*#__PURE__*/_jsx("rect", {
            stroke: "null",
            x: "40.60364",
            y: "36.93863",
            className: "st1",
            width: "9.62674",
            height: "29.52148",
            fill: "#000000",
            id: "svg_40"
          })
        }), /*#__PURE__*/_jsx("path", {
          stroke: "null",
          className: "st2",
          d: "m40.60364,46.11846c2.50406,1.77338 5.95411,2.97301 9.62674,0.26079l0,-8.24098l-9.62674,0l0,7.98019z",
          opacity: "0.8",
          fill: "#000000",
          id: "svg_41"
        }), /*#__PURE__*/_jsx("path", {
          stroke: "null",
          className: "st3",
          d: "m69.4282,23.89911l-20.58897,19.24634c-0.94598,0.88669 -2.17019,1.35611 -3.45004,1.35611c-1.22421,0 -2.50406,-0.46942 -3.45004,-1.35611c-1.89196,-1.77338 -1.89196,-4.69423 0,-6.4676l20.42204,-19.29849c0.94598,-0.88669 2.17019,-1.35611 3.50569,-1.35611c4.45167,-0.05216 6.67751,4.95502 3.56134,7.87587z",
          fill: "url(#SVGID_1_)",
          id: "svg_42"
        }), /*#__PURE__*/_jsx("path", {
          stroke: "null",
          className: "st4",
          d: "m48.72794,36.52137l-7.23396,-6.78055c-3.67263,-3.44243 -9.62674,-3.44243 -13.29936,0l-0.22258,0.20863l14.02276,13.14384c0.94598,0.88669 2.17019,1.35611 3.45004,1.35611c1.22421,0 2.44842,-0.41726 3.3944,-1.30395c1.94761,-1.77338 1.83631,-4.79854 -0.11129,-6.62408z",
          fill: "url(#SVGID_2_)",
          id: "svg_43"
        }), /*#__PURE__*/_jsx("path", {
          stroke: "null",
          className: "st5",
          d: "m65.92251,15.97108c-1.3355,0 -2.55971,0.46942 -3.50569,1.35611l-17.02764,16.06469c0,0 5.73153,7.56292 10.68401,2.92085l13.35501,-12.46578c3.11617,-2.8687 0.89033,-7.87587 -3.50569,-7.87587z",
          fill: "url(#SVGID_3_)",
          id: "svg_44"
        }), /*#__PURE__*/_jsx("path", {
          stroke: "null",
          className: "st6",
          d: "m90.12847,49.24794c0,2.8687 -0.94598,5.16365 -2.89359,6.98918c-1.94761,1.82553 -4.39602,2.71222 -7.34526,2.71222c-2.94923,0 -5.342,-0.88669 -7.28961,-2.71222c-1.89196,-1.82553 -2.89359,-4.17265 -2.89359,-6.98918c0,-2.8687 0.94598,-5.16365 2.89359,-6.98918c1.89196,-1.82553 4.34038,-2.71222 7.28961,-2.71222c2.94923,0 5.39765,0.88669 7.34526,2.71222c1.89196,1.82553 2.89359,4.12049 2.89359,6.98918l0,-13.14384c-2.83794,-3.33812 -6.84444,-5.00718 -11.96386,-5.00718c-4.89684,0 -9.12592,1.77338 -12.63161,5.26797c-3.50569,3.49459 -5.28636,7.82371 -5.28636,12.93521c0,5.11149 1.78067,9.38846 5.28636,12.93521c3.50569,3.49459 7.73478,5.26797 12.63161,5.26797c5.17507,0 9.12592,-1.66906 11.96386,-5.00718l0,-13.24816z",
          fill: "url(#SVGID_4_)",
          id: "svg_45"
        }), /*#__PURE__*/_jsx("path", {
          stroke: "null",
          className: "st7",
          d: "m149.66956,66.9817c4.61861,-0.93885 8.29124,-3.2338 10.96224,-6.88487l-7.62349,-4.12049c-1.83631,2.29496 -4.61861,3.44243 -8.23559,3.44243c-5.62023,0 -9.07028,-2.13848 -10.35013,-6.4676c0,-0.05216 -0.33388,14.29132 15.24697,14.03053z",
          fill: "url(#SVGID_5_)",
          id: "svg_46"
        }), /*#__PURE__*/_jsx("path", {
          stroke: "null",
          className: "st8",
          d: "m178.60541,35.89547c0,0 -9.51544,14.13484 -9.51544,5.16365l0,-9.02335l9.51544,0l0,3.8597z",
          fill: "url(#SVGID_6_)",
          id: "svg_47"
        }), /*#__PURE__*/_jsx("path", {
          stroke: "null",
          className: "st9",
          d: "m239.42636,49.24794c0,2.8687 -0.94598,5.16365 -2.89359,6.98918c-1.89196,1.82553 -4.34038,2.71222 -7.28961,2.71222c-2.94923,0 -5.39765,-0.88669 -7.34526,-2.71222c-1.94761,-1.82553 -2.89359,-4.17265 -2.89359,-6.98918c0,-2.8687 0.94598,-5.16365 2.89359,-6.98918c1.94761,-1.82553 4.39602,-2.71222 7.34526,-2.71222c2.94923,0 5.342,0.88669 7.28961,2.71222c1.94761,1.82553 2.89359,4.12049 2.89359,6.98918l0,-13.14384c-2.78229,-3.33812 -6.7888,-5.00718 -11.90822,-5.00718c-4.95248,0 -9.18157,1.77338 -12.68726,5.26797c-3.50569,3.49459 -5.28636,7.82371 -5.28636,12.93521c0,5.11149 1.72502,9.38846 5.28636,12.93521c3.50569,3.49459 7.73478,5.26797 12.68726,5.26797c5.17507,0 9.12592,-1.66906 11.90822,-5.00718l0,-13.24816z",
          fill: "#000000",
          id: "svg_48"
        }), /*#__PURE__*/_jsx("path", {
          stroke: "null",
          className: "st10",
          d: "m285.55679,49.24794c0,2.8687 -0.94598,5.16365 -2.89359,6.98918c-1.94761,1.82553 -4.39602,2.71222 -7.34526,2.71222c-2.94923,0 -5.342,-0.88669 -7.28961,-2.71222c-1.89196,-1.82553 -2.89359,-4.17265 -2.89359,-6.98918c0,-2.8687 0.94598,-5.16365 2.89359,-6.98918c1.89196,-1.82553 4.34038,-2.71222 7.28961,-2.71222c2.94923,0 5.39765,0.88669 7.34526,2.71222c1.89196,1.82553 2.89359,4.12049 2.89359,6.98918l0,-13.14384c-2.83794,-3.33812 -6.84444,-5.00718 -11.96386,-5.00718c-4.89684,0 -9.12592,1.77338 -12.63161,5.26797c-3.50569,3.49459 -5.28636,7.82371 -5.28636,12.93521c0,5.11149 1.72502,9.38846 5.28636,12.93521c3.50569,3.49459 7.73478,5.26797 12.63161,5.26797c5.17507,0 9.12592,-1.66906 11.96386,-5.00718l0,-13.24816z",
          fill: "#000000",
          id: "svg_49"
        }), /*#__PURE__*/_jsx("path", {
          stroke: "null",
          className: "st11",
          d: "m302.19491,52.06448l0,14.39563l9.62674,0l0,-18.41181c0,-4.8507 2.33713,-7.40645 6.95573,-7.7194c-3.72827,0.20863 -16.58247,0.67806 -16.58247,11.73557z",
          fill: "#000000",
          id: "svg_50"
        }), /*#__PURE__*/_jsx("path", {
          stroke: "null",
          className: "st12",
          d: "m31.58901,66.72091l-13.63324,0c-5.73153,0 -10.40578,-4.38128 -10.40578,-9.75356l0,-41.36137c0,-5.37228 4.67425,-9.75356 10.40578,-9.75356l58.87334,0c5.73153,0 10.40578,4.38128 10.40578,9.75356l0,9.75356c0,0.991 -0.83469,1.82553 -1.94761,1.82553s-1.94761,-0.78237 -1.94761,-1.82553l0,-9.75356c0,-3.39028 -2.94923,-6.15466 -6.56621,-6.15466l-58.81769,0c-3.61698,0 -6.56621,2.76438 -6.56621,6.15466l0,41.36137c0,3.39028 2.94923,6.15466 6.56621,6.15466l13.63324,0c1.05727,0 1.94761,0.78237 1.94761,1.82553s-0.89033,1.77338 -1.94761,1.77338z",
          fill: "url(#SVGID_10_)",
          id: "svg_51"
        }), /*#__PURE__*/_jsx("path", {
          stroke: "null",
          className: "st13",
          d: "m61.02568,3.55745l0,8.18882c0,0.73021 -0.33388,1.40827 -0.83469,1.87769c-0.50081,0.46942 -1.22421,0.78237 -2.00325,0.78237c-1.55808,0 -2.83794,-1.19964 -2.83794,-2.6079l0,-8.18882c0,-1.46043 1.27986,-2.6079 2.83794,-2.6079c1.55808,-0.05216 2.83794,1.09532 2.83794,2.55575z",
          fill: "url(#SVGID_11_)",
          id: "svg_52"
        }), /*#__PURE__*/_jsx("path", {
          stroke: "null",
          className: "st14",
          d: "m39.32378,3.55745l0,8.18882c0,0.73021 -0.33388,1.40827 -0.83469,1.87769c-0.50081,0.46942 -1.22421,0.78237 -2.00325,0.78237c-1.55808,0 -2.78229,-1.19964 -2.78229,-2.6079l0,-8.18882c0,-1.46043 1.27986,-2.6079 2.78229,-2.6079c1.61373,-0.05216 2.83794,1.09532 2.83794,2.55575z",
          fill: "url(#SVGID_12_)",
          id: "svg_53"
        })]
      })]
    })]
  }) : /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    version: "1.1",
    viewBox: "0 0 305 270",
    children: [/*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("radialGradient", {
        gradientTransform: "matrix(1,0,0,1,-346.29998779296875,-353.70001220703125)",
        gradientUnits: "userSpaceOnUse",
        r: "332.3373",
        cy: "305.8152",
        cx: "291.0811",
        id: "SVGID_1_",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#00FFFF",
          offset: "0"
        }), /*#__PURE__*/_jsx("stop", {
          stopColor: "#29ABE2",
          offset: "1"
        })]
      }), /*#__PURE__*/_jsxs("radialGradient", {
        gradientTransform: "matrix(1,0,0,1,-346.29998779296875,-353.70001220703125)",
        gradientUnits: "userSpaceOnUse",
        r: "332.3373",
        cy: "305.8152",
        cx: "291.0811",
        id: "SVGID_2_",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#00FFFF",
          offset: "0"
        }), /*#__PURE__*/_jsx("stop", {
          stopColor: "#29ABE2",
          offset: "1"
        })]
      }), /*#__PURE__*/_jsxs("radialGradient", {
        gradientTransform: "matrix(1,0,0,1,-346.29998779296875,-353.70001220703125)",
        gradientUnits: "userSpaceOnUse",
        r: "179.3502",
        cy: "545.9091",
        cx: "448.3648",
        id: "SVGID_3_",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#1B1464",
          offset: "0"
        }), /*#__PURE__*/_jsx("stop", {
          stopColor: "#29ABE2",
          stopOpacity: "0",
          offset: "1"
        })]
      }), /*#__PURE__*/_jsxs("radialGradient", {
        gradientTransform: "matrix(1,0,0,1,-346.29998779296875,-353.70001220703125)",
        gradientUnits: "userSpaceOnUse",
        r: "339.579",
        cy: "285.2516",
        cx: "296.9167",
        id: "SVGID_4_",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#00FFFF",
          offset: "0"
        }), /*#__PURE__*/_jsx("stop", {
          stopColor: "#29ABE2",
          offset: "1"
        })]
      }), /*#__PURE__*/_jsxs("radialGradient", {
        gradientTransform: "matrix(1,0,0,1,-346.29998779296875,-353.70001220703125)",
        gradientUnits: "userSpaceOnUse",
        r: "339.579",
        cy: "285.2516",
        cx: "296.9167",
        id: "SVGID_5_",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#00FFFF",
          offset: "0"
        }), /*#__PURE__*/_jsx("stop", {
          stopColor: "#29ABE2",
          offset: "1"
        })]
      }), /*#__PURE__*/_jsxs("radialGradient", {
        gradientTransform: "matrix(1,0,0,1,-346.29998779296875,-353.70001220703125)",
        gradientUnits: "userSpaceOnUse",
        r: "339.579",
        cy: "285.2516",
        cx: "296.9167",
        id: "SVGID_6_",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#00FFFF",
          offset: "0"
        }), /*#__PURE__*/_jsx("stop", {
          stopColor: "#29ABE2",
          offset: "1"
        })]
      })]
    }), /*#__PURE__*/_jsx("g", {
      children: /*#__PURE__*/_jsxs("g", {
        id: "svg_2",
        children: [/*#__PURE__*/_jsx("g", {
          fill: "#6D97AB",
          id: "svg_3",
          children: /*#__PURE__*/_jsx("rect", {
            id: "svg_4",
            fill: "#6D97AB",
            height: "120.7",
            width: "36.8",
            className: "st1",
            y: "146.99999",
            x: "133.00001"
          })
        }), /*#__PURE__*/_jsx("path", {
          id: "svg_5",
          fill: "#CCCCCC",
          opacity: "0.8",
          d: "m133.00001,184.39999c9.6,7.2 22.9,12.1 36.8,1.1l0,-33.7l-36.8,0l0,32.6z",
          className: "st2"
        }), /*#__PURE__*/_jsx("path", {
          id: "svg_6",
          fill: "url(#SVGID_1_)",
          d: "m243.40001,93.59999l-78.7,78.5c-3.6,3.6 -8.4,5.5 -13.2,5.5c-4.8,0 -9.5,-1.8 -13.2,-5.5c-7.3,-7.3 -7.3,-19.1 0,-26.4l78.3,-78.9c3.5,-3.6 8.4,-5.6 13.4,-5.6c16.9,0.1 25.3,20.5 13.4,32.4z",
          className: "st3"
        }), /*#__PURE__*/_jsx("path", {
          id: "svg_7",
          fill: "url(#SVGID_2_)",
          d: "m164.20001,145.39999l-27.6,-27.6c-14.1,-14.1 -36.9,-14.1 -51,0l-0.9,0.9l53.6,53.6c3.6,3.6 8.4,5.5 13.2,5.5c4.7,0 9.4,-1.8 13,-5.3c7.4,-7.4 7,-19.8 -0.3,-27.1z",
          className: "st4"
        }), /*#__PURE__*/_jsx("path", {
          id: "svg_8",
          fill: "url(#SVGID_3_)",
          d: "m230.00001,61.29999c-5.1,0 -9.9,2 -13.4,5.6l-65.2,65.7c0,0 22,30.8 40.9,12l51.1,-50.9c11.9,-12 3.5,-32.4 -13.4,-32.4z",
          className: "st5"
        }), /*#__PURE__*/_jsx("path", {
          id: "svg_9",
          fill: "url(#SVGID_4_)",
          d: "m265.20001,20.09999l-225.4,0c-21.9,0 -39.8,17.9 -39.8,39.8l0,39.7l0,129.2c0,21.9 17.9,39.8 39.8,39.8l52.2,0c4.1,0 7.4,-3.3 7.4,-7.4c0,-4.1 -3.3,-7.4 -7.4,-7.4l-52.2,0c-13.8,0 -25.1,-11.3 -25.1,-25.1l0,-129.1l0,-39.7c0,-13.8 11.3,-25.1 25.1,-25.1l225.4,0c13.8,0 25.1,11.3 25.1,25.1l0,39.7l0,129.2c0,13.8 -11.3,25.1 -25.1,25.1l-52.2,0c-4.1,0 -7.4,3.3 -7.4,7.4c0,4.1 3.3,7.4 7.4,7.4l52.2,0c21.9,0 39.8,-17.9 39.8,-39.8l0,-129.3l0,-39.7c0,-22 -17.8,-39.8 -39.8,-39.8z",
          className: "st6"
        }), /*#__PURE__*/_jsx("path", {
          id: "svg_10",
          fill: "url(#SVGID_5_)",
          d: "m204.70001,10.69999l0,33.4c0,3 -1.2,5.6 -3.1,7.6c-1.9,1.9 -4.6,3.1 -7.6,3.1c-5.9,0 -10.8,-4.8 -10.8,-10.7l0,-33.4c0,-5.9 4.8,-10.7 10.8,-10.7c5.9,0 10.7,4.8 10.7,10.7z",
          className: "st7"
        }), /*#__PURE__*/_jsx("path", {
          id: "svg_11",
          fill: "url(#SVGID_6_)",
          d: "m121.80001,10.69999l0,33.4c0,3 -1.2,5.6 -3.1,7.6c-1.9,1.9 -4.6,3.1 -7.6,3.1c-5.9,0 -10.7,-4.8 -10.7,-10.7l0,-33.4c0,-5.9 4.8,-10.7 10.7,-10.7c5.9,0 10.7,4.8 10.7,10.7z",
          className: "st8"
        })]
      })
    })]
  });
  return gotToRoot ? /*#__PURE__*/_jsx(Link, {
    href: "/",
    children: /*#__PURE__*/_jsxs("a", {
      className: "w-full",
      children: [/*#__PURE__*/_jsx("span", {
        className: "sr-only",
        children: "Yalendar"
      }), /*#__PURE__*/_jsx("div", {
        children: logo
      })]
    })
  }) : logo;
}
export default AppLogo;